import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

export type TViewDetailsModalContentProps = {
  title: string;
  description?: string;
  content: { label: string; value: string }[];
};
export const ViewDetailsModalContent = ({
  title,
  description,
  content,
}: TViewDetailsModalContentProps) => {
  return (
    <div>
      <DialogHeader className="flex flex-col gap-1 items-start border-none">
        <DialogTitle>{title}</DialogTitle>
        {description ? (
          <DialogDescription>{description}</DialogDescription>
        ) : null}
      </DialogHeader>
      <div className="flex flex-col gap-3 p-6 pt-0">
        {content.map((row) => (
          <div className="py-2 grid grid-cols-2 gap-16">
            <span className="txt-small-medium text-text-quaternary">
              {row.label}
            </span>
            <span className="txt-small-medium text-text-primary">
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
